var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-col',[_c('a',{staticClass:"fs-1_3 titlesdark--text ",on:{"click":this.exportExcel}},[_vm._v(_vm._s(_vm.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }